import React from "react";
import { useAppDispatch } from "../store/hooks";
import { resetModule } from "../store/features/moduleSlice";
import { clearState } from "../utils/cache";

interface ModuleResetButtonProps {
  className?: string;
  variant?: "compact" | "full";
}

export const ModuleResetButton: React.FC<ModuleResetButtonProps> = ({ 
  className = "", 
  variant = "full" 
}) => {
  const dispatch = useAppDispatch();

  const handleReset = () => {
    if (window.confirm("Are you sure? This will reset the module design and clear all data.")) {
      dispatch(resetModule());
      clearState();
    }
  };

  if (variant === "compact") {
    return (
      <button
        onClick={handleReset}
        className={`px-3 py-1 bg-red-600 text-white rounded text-sm hover:bg-red-700 transition-colors flex items-center gap-1 ${className}`}
        title="Reset module design - Clear all data and start over"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
        Reset
      </button>
    );
  }

  return (
    <div className={`flex flex-col ${className}`}>
      <button
        onClick={handleReset}
        className="w-full px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors flex items-center justify-center gap-2"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
        Reset Module Design
      </button>
      <p className="text-xs text-gray-600 mt-1 text-center">
        Clear all data and start over
      </p>
    </div>
  );
};
